import { ChevronUp, ShieldCheck, Package, Clock, RefreshCw, Lock, Trash2, Book, Truck, AlertCircle, Link2 } from 'lucide-react';
import { Link } from 'react-router-dom';

const TermsPage = () => {
  const sections = [
    {
      icon: <ShieldCheck className="w-6 h-6" />,
      title: "1. Introducción",
      content: (
        <>
          <p className="mb-4">En SAHEZ MEDIC valoramos tu privacidad y estamos comprometidos a proteger la información personal que compartes con nosotros. Estos Términos rigen el uso de nuestra tienda de accesorios médicos en República Dominicana.</p>
          <p>www.tiendasahezmedic.com.do asegura el cumplimiento de la Ley de Protección de Datos Personales y Garantía de Derechos Digitales.</p>
        </>
      )
    },
    {
      icon: <Package className="w-6 h-6" />,
      title: "2. Información del Dispositivo",
      content: (
        <>
          <p className="mb-2">Al acceder a www.sahezmedic.com recopilamos automáticamente:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Tipo de navegador y dirección IP</li>
            <li>Zona horaria y cookies instaladas</li>
            <li>Páginas/productos visualizados</li>
            <li>Términos de búsqueda utilizados</li>
            <li>Detalles de interacción con el sitio</li>
          </ul>
          <p className="mt-4">Esta información técnica no se considera dato personal.</p>
        </>
      )
    },
    {
      icon: <Lock className="w-6 h-6" />,
      title: "3. Seguridad de Datos",
      content: (
        <>
          <div className="space-y-4">
            <p>Implementamos medidas técnicas y organizativas para garantizar:</p>
            <ul className="list-decimal pl-6 space-y-4">
              <li>
                <strong>1.1 Entrega de productos:</strong> 
                <p className="mt-1">Compromiso de entrega de productos adquiridos.</p>
              </li>
              <li>
                <strong>1.2 Plazos de entrega:</strong>
                <p className="mt-1">Estimaciones aproximadas sujetas a factores externos (clima, huelgas, problemas logísticos).</p>
              </li>
              <li>
                <strong>1.3 Costos de envío:</strong>
                <p className="mt-1">Calculados según destino final, informados al momento de recepción. Variables según peso, volumen y precio.</p>
              </li>
              <li>
                <strong>1.4 Direcciones incorrectas:</strong>
                <p className="mt-1">Costos adicionales por errores en dirección proporcionada serán asumidos por el cliente.</p>
              </li>
            </ul>
          </div>
        </>
      )
    },
    {
      icon: <Truck className="w-6 h-6" />,
      title: "4. Política de Envíos",
      content: (
        <>
          <ul className="list-disc pl-6 space-y-2">
            <li>Envíos nacionales e internacionales</li>
            <li>Seguimiento en línea disponible</li>
            <li>Procesamiento en 24-48 horas hábiles</li>
          </ul>
        </>
      )
    },
    {
      icon: <RefreshCw className="w-6 h-6" />,
      title: "5. Devoluciones",
      content: (
        <>
          <ul className="list-disc pl-6 space-y-2">
            <li>Productos deben estar en estado original</li>
            <li>Proceso de devolución inicia por correo electrónico</li>
            <li>Costos de envío corren por cuenta del cliente</li>
            <li>Procesamiento dentro de 5-10 días hábiles</li>
          </ul>
        </>
      )
    },
    {
      icon: <AlertCircle className="w-6 h-6" />,
      title: "6. Limitaciones de Responsabilidad",
      content: (
        <>
          <ul className="list-disc pl-6 space-y-2">
            <li>Daños por uso incorrecto de productos</li>
            <li>Pérdidas por información médica incorrecta</li>
            <li>Problemas derivados de interrupciones del servicio</li>
          </ul>
        </>
      )
    },
    {
      icon: <Clock className="w-6 h-6" />,
      title: "7. Modificaciones",
      content: (
        <>
          <ul className="list-disc pl-6 space-y-2">
            <li>Derecho a modificar términos unilateralmente</li>
            <li>Cambios efectivos al publicarse en el sitio</li>
            <li>Notificación vía correo electrónico</li>
          </ul>
        </>
      )
    },
    {
      icon: <Book className="w-6 h-6" />,
      title: "8. Propiedad Intelectual",
      content: (
        <>
          <div className="space-y-4">
            <p>Queda estrictamente prohibido:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Reproducir contenido sin autorización</li>
              <li>Modificar o distribuir material protegido</li>
              <li>Usar marcas registradas o diseños patentados</li>
            </ul>
            <div className="p-4 bg-main-bg/20 rounded-lg">
              <p className="font-semibold">Responsabilidades del Usuario:</p>
              <ul className="list-circle pl-6 mt-2 space-y-2">
                <li>Verificar que el contenido compartido no infrinja derechos de terceros</li>
                <li>Evitar uso de herramientas para copia ilegal</li>
                <li>Aceptar consecuencias legales por infracciones</li>
              </ul>
            </div>
          </div>
        </>
      )
    },
    {
      icon: <Trash2 className="w-6 h-6" />,
      title: "9. Eliminación de Datos",
      content: (
        <>
          <p>Solicitudes de eliminación deben enviarse a:</p>
          <a href="mailto:info@sahezmedic.com" className="text-primary hover:text-dark mt-2 inline-block">
            info@sahezmedic.com
          </a>
          <p className="mt-4">Procesamiento dentro de 72 horas hábiles</p>
        </>
      )
    },
    {
      icon: <Link2 className="w-6 h-6" />,
      title: "10. Enlaces Rápidos",
      content: (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <p className="font-semibold">Explorar</p>
            <ul className="space-y-1">
              {['Inicio', 'FAQs'].map((link) => (
                <li key={link}>
                  <Link to="/" className="text-dark hover:text-primary transition-colors">
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="space-y-2">
            <p className="font-semibold">Nuestra empresa</p>
            <ul className="space-y-1">
              {['Política de privacidad', 'Términos de servicio'].map((link) => (
                <li key={link}>
                  <Link to="/" className="text-dark hover:text-primary transition-colors">
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="space-y-2">
            <p className="font-semibold">Síganos</p>
            <ul className="space-y-1">
              {['Facebook', 'Instagram', 'LinkedIn'].map((link) => (
                <li key={link}>
                  <Link to="/" className="text-dark hover:text-primary transition-colors">
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )
    }
  ];

  
  return (
    <div className="min-h-screen bg-main-bg">
      <header className="bg-gradient-to-r from-primary to-dark text-main-bg py-20 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h1 
           
            className="text-4xl md:text-5xl font-poppins font-bold mb-4"
          >
            Términos de Servicio
          </h1>
          <p className="text-lg font-montserrat max-w-3xl mx-auto">
            Regulaciones para el uso de www.sahezmedic.com.do según legislación dominicana
          </p>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-4 gap-12">
          <div 
            className="hidden lg:block lg:col-span-1 sticky top-20 h-fit"
            
          >
            <div className="bg-section-bg p-6 rounded-xl shadow-lg">
              <h2 className="text-xl font-poppins font-semibold text-dark mb-4">Índice</h2>
              <ul className="space-y-3 font-montserrat">
                {sections.map((section, index) => (
                  <li key={index}>
                    <a 
                      href={`#section-${index + 1}`} 
                      className="text-dark hover:text-primary transition-colors flex items-center gap-2"
                    >
                      <ChevronUp className="w-4 h-4 rotate-45" />
                      {section.title.split(' ').slice(1).join(' ')}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div 
            className="lg:col-span-3 space-y-12"
          
          >
            {sections.map((section, index) => (
              <section 
                key={index}
                id={`section-${index + 1}`}
                className="bg-section-bg p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow"
              >
                <div className="flex items-center gap-4 mb-6">
                  <div className="bg-primary p-3 rounded-lg text-main-bg">
                    {section.icon}
                  </div>
                  <h2 className="text-2xl font-poppins font-semibold text-dark">
                    {section.title}
                  </h2>
                </div>
                <div className="text-gray-700 font-montserrat leading-relaxed">
                  {section.content}
                </div>
              </section>
            ))}
          </div>
        </div>

       <div 
  className="mt-16 p-8 border-2 border-primary rounded-xl bg-main-bg"
 
>
  <div className="max-w-4xl mx-auto text-center">
    <ShieldCheck className="w-12 h-12 text-primary mx-auto mb-4" />
    <h3 className="text-2xl font-poppins font-semibold text-dark mb-4">
      Cumplimiento Legal
    </h3>
    <p className="font-montserrat text-gray-600 mb-6">
      Reservamos el derecho de suspender cuentas y remover contenido infractor. Infracciones pueden resultar en acciones legales según Ley No. 172-13.
    </p>
    <div className="flex flex-col sm:flex-row justify-center gap-4">
     
      <Link 
        to="/privacy" 
        className="inline-block bg-dark text-main-bg px-6 py-2 rounded-lg font-poppins hover:bg-primary transition-colors w-full sm:w-auto text-center"
      >
        Ver Política de Privacidad
      </Link>
    </div>
  </div>
</div>


        <button type='button' title='scroll to top'
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-8 right-8 bg-dark text-main-bg p-3 rounded-full shadow-xl hover:bg-primary transition-colors"
          
        >
          <ChevronUp className="w-6 h-6" />
        </button>
      </main>
    </div>
  );
};

export default TermsPage;